import api from "@/services/api";
import type { IUser } from "../types/user";

export const usersService = {
	async getUsersAll(isActive?: boolean): Promise<IUser[]> {
		const response = await api.get<IUser[]>("/api/auth/users", {
			params: typeof isActive === "boolean" ? { isActive } : undefined,
		});
		return response.data;
	},

	async updateUser(
		userId: string,
		data: { name: string; email: string; groupIds?: number[] }
	): Promise<IUser> {
		const response = await api.put<IUser>(
			`/api/auth/user/${userId}/update/personal-info`,
			data
		);
		return response.data;
	},

	async createUser(data: {
		name: string;
		email: string;
		cpf: string;
		role: string;
		groupIds?: number[];
	}): Promise<IUser> {
		const response = await api.post<IUser>("/api/auth/user/register", data);
		return response.data;
	},

	async updateUserStatus(
		userId: string,
		data: { isActive: boolean }
	): Promise<IUser> {
		const response = await api.put<IUser>(
			`/api/auth/user/${userId}/status`,
			data
		);
		return response.data;
	},
};
